import { clx } from '@medusajs/ui';
import { useQuery } from '@tanstack/react-query';

import AppLink from '@adapters/app-link';
import { topSearchQueryOptions } from '@lib/query/options/cms';

const PopularSearches = () => {
  const { data, isError } = useQuery(topSearchQueryOptions);

  const topSearches = data?.items ?? [];

  // Don't render if error or no items - graceful degradation for CMS failures
  if (isError || topSearches.length === 0) {
    return null;
  }

  return (
    <div className="text-base font-normal flex w-full items-center gap-4 overflow-auto pb-1 pl-6 lg:justify-center lg:pt-3">
      <div className="text-black-10 whitespace-nowrap">熱門搜尋</div>

      {topSearches.map((search) => (
        <AppLink
          className={clx(
            'tab-pill border-white-20 bg-white-20 text-black-50 hover:border-primary-10 hover:text-primary-50 active:bg-primary-10 cursor-pointer whitespace-nowrap rounded-full border px-3 py-1 transition-all'
          )}
          key={search.id}
          href={search.link}
        >
          {search.keyword}
        </AppLink>
      ))}
    </div>
  );
};

export default PopularSearches;
